/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqItem } from '../../models/faq-item';

export interface CreateFaq$Params {
      body?: FaqItem
}

export function createFaq(http: HttpClient, rootUrl: string, params?: CreateFaq$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqItem>> {
  const rb = new RequestBuilder(rootUrl, createFaq.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FaqItem>;
    })
  );
}

createFaq.PATH = '/faq';
